import PropTypes from "prop-types"
import { percentageFormatter, numberFormatter } from "helpers/formatters/numbers"
import { darken } from "helpers/colors"
import { Link } from "@mui/material"

function Row({ label, color, value, chartWidth, raw, openPositionProfile }) {
  return <div className="row-wrapper">
    <div className="chart-bar" style={{ background: darken(color, 0.7), width: chartWidth }} />
    <div className="value-wrapper">
      {openPositionProfile ? <Link
        className="label"
        href="#"
        onClick={() => openPositionProfile()}
        underline="hover"
      >
        {label}
      </Link> : <div className="label">{label}</div>}
      <div className="value">{raw ? numberFormatter(value) : percentageFormatter(value / 100)}</div>
    </div>
  </div>
}

Row.propTypes = {
  color: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  chartWidth: PropTypes.string.isRequired,
  raw: PropTypes.bool,
  openPositionProfile: PropTypes.func,
}

export default Row
